import React from 'react';
import {
  SectionHeading as UiSectionHeading,
  ToggleSwitch as UiToggleSwitch,
  ToggleRow as UiToggleRow,
} from '../../../../components/ui';

export const inputBaseClass =
  'block w-full rounded-md border border-slate-200 bg-white px-3.5 py-2.5 text-sm text-slate-900 shadow-sm transition placeholder:text-slate-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/30 disabled:cursor-not-allowed disabled:bg-slate-50 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-100 dark:placeholder:text-slate-500 dark:focus:border-sky-400 dark:focus:ring-sky-400/30';

export const primaryButtonClass =
  'inline-flex h-10 items-center justify-center gap-2 rounded-md bg-blue-600 px-5 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400/60 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-sky-500 dark:hover:bg-sky-400 dark:focus:ring-sky-300/40';

export const secondaryButtonClass =
  'inline-flex h-10 items-center justify-center gap-2 rounded-md border border-slate-200 bg-white px-5 text-sm font-semibold text-slate-700 shadow-sm transition hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-400/40 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700';

export const destructiveButtonClass =
  'inline-flex h-10 items-center justify-center gap-2 rounded-md bg-rose-600 px-5 text-sm font-semibold text-white shadow-sm transition hover:bg-rose-500 focus:outline-none focus:ring-2 focus:ring-rose-400/60 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-rose-600 dark:hover:bg-rose-500';

export const cardClass =
  'rounded-md border border-slate-200 bg-white p-5 shadow-sm transition dark:border-slate-700 dark:bg-slate-900/60';

export const SectionHeading = UiSectionHeading;

export function FieldLabel({ htmlFor, children, required, hint }) {
  return (
    <div className="flex items-center justify-between">
      <label
        htmlFor={htmlFor}
        className="text-xs font-semibold uppercase tracking-[0.08em] text-slate-500 dark:text-slate-400"
      >
        {children}
        {required && <span className="ml-0.5 text-rose-500">*</span>}
      </label>
      {hint && (
        <span className="text-[11px] text-slate-400 dark:text-slate-500">
          {hint}
        </span>
      )}
    </div>
  );
}

export function FieldError({ message }) {
  if (!message) return <div className="h-4" aria-hidden="true" />;
  return (
    <p className="text-xs font-medium text-rose-500 dark:text-rose-400">
      {message}
    </p>
  );
}

export const ToggleSwitch = UiToggleSwitch;
export const ToggleRow = UiToggleRow;

export function DetailRow({ label, children }) {
  return (
    <div className="flex flex-col gap-1 border-b border-slate-100 py-3 last:border-b-0 sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 dark:border-slate-800">
      <dt className="text-xs font-semibold uppercase tracking-[0.08em] text-slate-500 dark:text-slate-400">
        {label}
      </dt>
      <dd className="text-sm text-slate-800 sm:col-span-2 dark:text-slate-200">
        {children || (
          <span className="text-slate-400 dark:text-slate-500">—</span>
        )}
      </dd>
    </div>
  );
}
